export const iconFontAwesomeHumanitarianPlateWheat = (
	<i className="fa-solid fa-plate-wheat"></i>
);
